import { coverageResponse } from "@/models/equip-api-response-objects/coverageResponse";
import { Get } from "./utilities-api";
import {
  userInfoResponse,
  userRoleResponse,
} from "@/models/equip-api-response-objects/userInfoResponse";

export function GetUserInfo(userId: string | undefined = undefined): Promise<userInfoResponse> {
  return Get<userInfoResponse>("/user/info", {
    userId: userId,
  });
}

export function GetCoverage(
  userId: string | undefined = undefined,
  coverageRole: string = "analyst"
): Promise<coverageResponse[]> {
  return Get<coverageResponse[]>("/user/coverage", {
    userId: userId,
    coverageRole: coverageRole,
  });
}

export function GetUserRoles(): Promise<userRoleResponse> {
  return Get<userRoleResponse>("/user/roles", {});
}
